module.exports = __webpack_public_path__ + "img/loader_v6.41242be.png";